import { createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-287cd64e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "h5-search" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hero" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "hero-content" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "hero-icon" }, [
      /*#__PURE__*/_createElementVNode("i", { class: "fa fa-file-text-o" })
    ]),
    /*#__PURE__*/_createElementVNode("h1", null, "检测报告查询"),
    /*#__PURE__*/_createElementVNode("p", null, "输入查询验证码或相关信息查询检测报告")
  ])
], -1))
const _hoisted_3 = { class: "search-card" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "search-title" }, "报告查询", -1))
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "查询验证码", -1))
const _hoisted_7 = { class: "input-wrap" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-file-text-o" }, null, -1))
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "关键词", -1))
const _hoisted_11 = { class: "input-wrap" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1))
const _hoisted_13 = ["disabled"]
const _hoisted_14 = {
  key: 0,
  class: "result-card error"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-exclamation-circle" }, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "您输入的编号有误，查询的报告不存在", -1))
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = {
  key: 1,
  class: "result-card success"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "result-header" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-check-circle" }),
  /*#__PURE__*/_createElementVNode("span", null, "查询成功")
], -1))
const _hoisted_20 = { class: "result-body" }
const _hoisted_21 = { class: "result-item" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "报告编号", -1))
const _hoisted_23 = { class: "value" }
const _hoisted_24 = { class: "result-item" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "检测项目", -1))
const _hoisted_26 = { class: "value" }
const _hoisted_27 = { class: "result-item" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "检测结果", -1))
const _hoisted_29 = { class: "result-footer" }
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" 查看完整报告 ")
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-angle-right" }, null, -1))
const _hoisted_32 = [
  _hoisted_30,
  _hoisted_31
]
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "rules-card" }, [
  /*#__PURE__*/_createElementVNode("h4", null, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-info-circle" }),
    /*#__PURE__*/_createTextVNode(" 查询说明")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, "1、输入查询验证码查询"),
  /*#__PURE__*/_createElementVNode("p", null, "2、输入报告编号+公司名称查询"),
  /*#__PURE__*/_createElementVNode("p", null, "3、输入报告编号+产品名称查询"),
  /*#__PURE__*/_createElementVNode("p", null, "4、输入报告编号+检测项目查询"),
  /*#__PURE__*/_createElementVNode("p", null, "报告所有权（含报告真实性）的法律责任由上传者承担，本平台仅提供报告查询服务。")
], -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer-space" }, null, -1))

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.code) = $event)),
            type: "text",
            placeholder: "请输入查询验证码或报告编号",
            onKeyup: _cache[1] || (_cache[1] = _withKeys((...args) => ($options.handleSearch && $options.handleSearch(...args)), ["enter"]))
          }, null, 544), [
            [_vModelText, $data.code]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($data.code1) = $event)),
            type: "text",
            placeholder: "请输入公司名称、产品名称或检测项目名称",
            onKeyup: _cache[3] || (_cache[3] = _withKeys((...args) => ($options.handleSearch && $options.handleSearch(...args)), ["enter"]))
          }, null, 544), [
            [_vModelText, $data.code1]
          ])
        ])
      ]),
      _createElementVNode("button", {
        class: "submit-btn",
        disabled: $data.loading,
        onClick: _cache[4] || (_cache[4] = (...args) => ($options.handleSearch && $options.handleSearch(...args)))
      }, _toDisplayString($data.loading ? '查询中...' : '查 询'), 9, _hoisted_13)
    ]),
    ($data.showError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_17))
      : _createCommentVNode("", true),
    ($data.showInfo)
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _hoisted_19,
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              _createElementVNode("span", _hoisted_23, _toDisplayString($data.data.code), 1)
            ]),
            _createElementVNode("div", _hoisted_24, [
              _hoisted_25,
              _createElementVNode("span", _hoisted_26, _toDisplayString($data.data.testProjectName || '-'), 1)
            ]),
            _createElementVNode("div", _hoisted_27, [
              _hoisted_28,
              _createElementVNode("span", {
                class: _normalizeClass(["value", $data.data.testResult === 1 ? 'pass' : 'fail'])
              }, _toDisplayString($data.data.testResult === 1 ? '符合' : '不符合'), 3)
            ])
          ]),
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("button", {
              class: "detail-btn",
              onClick: _cache[5] || (_cache[5] = (...args) => ($options.goToDetail && $options.goToDetail(...args)))
            }, _hoisted_32)
          ])
        ]))
      : _createCommentVNode("", true),
    _hoisted_33,
    _hoisted_34
  ]))
}